export default __webpack_public_path__ + "static/media/verified-badge-oil.b88fbf1c.png";